import { getAccreditationEditableStates } from "../../../hooks/useSettingManager"

export default function isAccreditationEditable(code: string = ""): boolean {
    const editableStates = getAccreditationEditableStates()
    return editableStates.includes(code)
}
